import React, { useState, useEffect } from "react";
import { Tab, Tabs } from "react-bootstrap";
//style
import style from "./payout.module.scss";
import { useSelector } from "react-redux";
import moment from "moment";
import PayoutService from "../../../service/payout";
//compoenents
import { PendingTable } from "./";

function Content(props) {
  let service = new PayoutService();
  const { currentTheme } = useSelector((state) => state.Theme);
  const [state, setState] = useState({
    filter: {
      start: moment().startOf("month"),
      end: moment(),
      label:
        moment().startOf("month").format("MMMM D, YYYY") +
        " - " +
        moment().format("MMMM D, YYYY"),
    },
    report: {
      totalRows: 0,
      data: [],
      pending: true,
      perPage: 10,
      inPage: 1,
    },
  });

  useEffect(() => {
    loadData(
      state.report.inPage,
      state.report.perPage,
      state.filter.start.format("Y-MM-DD"),
      state.filter.end.format("Y-MM-DD")
    );
  }, []);

  //load the data
  const loadData = (
    inPage = state.report.inPage,
    perPage = state.report.perPage,
    startDate = "",
    endDate = ""
  ) => {
    let start = (inPage - 1) * perPage;
    service.PendingTable(start, perPage, startDate, endDate).then((res) => {
      if (res.status) {
        setState((prevState) => ({
          ...prevState,
          report: {
            ...prevState.report,
            totalRows: res.data.count,
            data: res.data,
            pending: false,
          },
        }));
        console.log(state.report, "========== table");
      } else {
        if (res.error.code === 1002) {
          props.history.push("/logout");
        } else if (res.error.code === 1057) {
          props.history.push({
            pathname: "/dashboard",
            state: {
              error: true,
              message: "permissionDenied",
            },
          });
        }
      }
    });
  };

  //chanege filter date
  const filterChange = (start, end) => {
    setState((prevState) => ({
      ...prevState,
      filter: {
        ...prevState.filter,
        start: start,
        end: end,
        label:
          start.format("MMMM D, YYYY") + " - " + end.format("MMMM D, YYYY"),
      },
    }));
  };

  const resetButton = () => {
    setState((prevState) => ({
      ...prevState,
      filter: {
        start: moment().startOf("month"),
        end: moment(),
        label:
          moment().startOf("month").format("MMMM D, YYYY") +
          " - " +
          moment().format("MMMM D, YYYY"),
      },
    }));
    let StartDate = state.filter.start.format("Y-MM-DD");
    let EndDate = state.filter.end.format("Y-MM-DD");
    loadData(state.report.inPage, state.report.perPage, StartDate, EndDate);
  };

  //submit the filter button
  const submitFilter = () => {
    let StartDate = state.filter.start.format("Y-MM-DD");
    let EndDate = state.filter.end.format("Y-MM-DD");
    console.log(StartDate, EndDate);
    loadData(state.report.inPage, state.report.perPage, StartDate, EndDate);
  };

  const paginationchange = (inPage, perPage = state.report.perPage) => {
    setState((prevState) => ({
      ...prevState,
      report: {
        ...prevState.report,
        inPage: inPage,
        perPage: perPage,
      },
    }));
    let StartDate = state.filter.start.format("Y-MM-DD");
    let EndDate = state.filter.end.format("Y-MM-DD");
    loadData(inPage, perPage, StartDate, EndDate);
  };

  const exportData = (type) => {
    let StartDate = state.filter.start.format("Y-MM-DD");
    let EndDate = state.filter.end.format("Y-MM-DD");
    console.log(
      "START AND END DATE BEFORE EXPORT API CALL",
      StartDate,
      EndDate
    );
    props.exportData(type, StartDate, EndDate);
  };

  const { t } = props;
  
  if (props.encashmentHistory) {
    return (
      <div className={style.summary}>
        <div
          className={`${
            currentTheme == "theme-dark"
              ? `${style.dark_mode_tabContent}`
              : `${style.tabContent}`
          }`}
        >
          {props.encashmentHistory && (
            <Tabs
              defaultActiveKey={`statement`}
              id="uncontrolled-tab-example"
              transition={false}
            >
              <Tab eventKey="statement" title="Encashment History">
                <div className={style.dataTable}></div>

                <PendingTable
                  {...state}
                  service={service}
                  exportdata={exportData}
                  changeDate={filterChange}
                  resetButton={resetButton}
                  submitFilter={submitFilter}
                  paginationchange={paginationchange}
                  ContentData={state.report.data.table_data}
                  cancelPopupHandler={props.paginationHandler.cancel}
                  loader={props.loader}
                  onSubmit={props.paginationHandler.submit}
                />
              </Tab>
            </Tabs>
          )}
        </div>
      </div>
    );
  }
  return <></>;
}

export default Content;
